<template>
  <div class="row">
    <div class="form-group col-md-12">
      <div class="card">
        <div class="card-header">
          <span>{{ $t('event.form.interest.title') }}</span>
          
          <div class="float-right">
            <a href="#section" name="section" v-on:click="expandOrCollapse">
              <span class="fa fa-expand fa-lg" v-if="!localVisible" ></span>
              <span class="fa fa-compress fa-lg" v-if="localVisible"></span>
            </a>
          </div>
        </div>
        <div class="card-body" v-if="localVisible">
          <div class="row">

            <div v-if="filteredEventProjects.length == 0 || filteredEventPersons.length == 0">
              {{ $t("form.aucun_donne") }}
            </div>

            <table id="dataTableEventProject" width="100%" cellspacing="0" class="table table-bordered table-striped dataTable" v-else>
             <thead>
                <tr>
                  <th width=400>{{ $t('event.form.person.name') }} \ {{ $t('event.form.project.name') }} </th>
                  <th v-for="project in filteredEventProjects" :key="project.id">{{ project.name }}</th>
                </tr>
              </thead>
              <tfoot>
                <tr>
                  <th>{{ $t('event.form.person.name') }} \ {{ $t('event.form.project.name') }} </th>
                  <th v-for="project in filteredEventProjects" :key="project.id">{{ project.name }}</th>
                </tr>
              </tfoot>
              <tbody>
                <tr v-for="person in filteredEventPersons" v-bind:data-id="person.id" :key="person.id">
                  <td>
                    {{ person.personType == 1 && person.member != null ? person.member.familyName + ', ' + person.member.name : 
                      (person.personType == 2 && person.associatedUser != null ? person.associatedUser.fullName : 
                      (person.personType == 3 && person.entrepreneur != null ? person.entrepreneur.familyName + ', ' + person.entrepreneur.name : 
                      (person.personType == 4 && person.partner != null ? person.partner.name : ''))) }}
                  </td>
                  <td v-for="project in filteredEventProjects" :key="project.id">
                    <label class="custom-control custom-checkbox">
                      <input type="checkbox" name="present" :checked="checkIsChecked(person, project)" class="custom-control-input" id="present" @click="f => selectInterest(person, project) ">
                      <span class="custom-control-indicator"></span>
                      <span class="custom-control-label">Oui</span>
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {EventServiceClient, EventProjectDto, EventPersonDto, EventInterestDto} from '../../shared/service-clients/service-clients'
  import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
  import CrudMixin from '../../shared/Mixin/CrudMixin'
  
  export default {
    name: 'CreateEventInterest',
    props: {
      eventProjects: {
        type: Array,
        default: [],
      },
      eventPersons: {
        type: Array,
        default: [],
      },
    },
    data() {
      return {
        localVisible: true,
      }
    },
    inject: ['$validator'],
    mixins: [CrudMixin],
    mounted: function() {
      let self = this
      setTimeout(function() {
        self.fetchData()
        self.setMode()
      }, 1000)
    },
    computed: {
      filteredEventProjects: function() {
        if (this.eventProjects == null) return []
        return _.filter(this.eventProjects, f => f.id != null && f.id != 0)
      },
      filteredEventPersons: function() {
        if (this.eventPersons == null) return []
        return _.filter(this.eventPersons, f => f.id != null && f.id != 0)
      },
    },
    methods: {
      checkIsChecked: function(person, project) {
        return _.find(person.eventInterests, f => f.eventProjectId == project.id) != null
      },
      selectInterest: function(person, project) {
        if (person.eventInterests == null) person.eventInterests = []

        let exist = _.find(person.eventInterests, f => f.eventProjectId == project.id)
        if (exist != null) person.eventInterests = _.filter(person.eventInterests, f => f.eventProjectId != project.id)
        else {
          let dto = new EventInterestDto()
          dto.init({eventPersonId: person.id, eventProjectId: project.id})
          person.eventInterests.push(dto)
        }
      },
      expandOrCollapse: function() {
        this.localVisible = !this.localVisible
      },
      fetchData: function() {},
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/events/CreateEventInterest.vue